export function getContractList(data) {
    let { getContractListRequest, getContractListError, getContractListResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'get_contract_list',
        this.createBundle('get_contract_list', { contract: data }, this.GET, getContractListRequest, getContractListResult, getContractListError)
    )
}
